import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export function useWelcomeModal() {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Only show welcome modal after user signs up (not on every visit)
    const hasSeenModal = localStorage.getItem('hasSeenWelcomeModal');
    const justSignedUp = sessionStorage.getItem('justSignedUp');
    
    if (user && justSignedUp && !hasSeenModal) {
      setIsOpen(true);
      sessionStorage.removeItem('justSignedUp');
    }
  }, [user]);

  const closeModal = () => {
    setIsOpen(false);
    localStorage.setItem('hasSeenWelcomeModal', 'true');
  };

  return { isOpen, closeModal };
}